import { IonPage, IonRouterOutlet } from "@ionic/react";
import { Redirect, Route, Switch } from "react-router";
import isAuthenticated from "../../../global/utils/isAuthenticated";
import PaginaNoEncontrada from "../../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import AdminProvider from "../context/Provider";
import routesAdmin from "./listRoutes";

const RouterAdmin = ({ match }) => {
  let isAdmin = localStorage.getItem("isAdmin");
  isAdmin = isAdmin ? JSON.parse(isAdmin) : false;
  return (
    <AdminProvider>
      <IonPage>
        <IonRouterOutlet>
          <Switch>
            {routesAdmin.map((route, key) => {
              return (
                <Route
                  exact
                  path={`${match.url}${route.path}`}
                  key={key}
                  render={({ props }) =>
                    !isAdmin ? (
                      <Redirect to="/consultaMedica" />
                    ) : (
                      <route.component {...props} />
                    )
                  }
                />
              );
            })}
            {/*  Aca debe ir la ruta 404  */}
            <Route path="*" component={PaginaNoEncontrada} />
          </Switch>
        </IonRouterOutlet>
      </IonPage>
    </AdminProvider>
  );
};

export default RouterAdmin;
